import InputFactory from "../../../../../components/InputFactory";
import CardView from "../../../../../components/common/CardView";
import SearchSelect from "../../../../../components/searchSelect/SearchSelect";
import RichText from "../../../../../components/common/RichText";
import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import FileUpload from "../../../../../components/common/FileUpload";
import BaseFormPage from "../../../../../base/BaseFormPage";
import {
  convertTo12Hour,
  formatDate,
  FloatingForm,
  SubmitImg,
} from "../../../../../components/common/Converter";
import { createNotification } from "../../../../../createNotification";
import { Button, dialog } from "nq-component";
import MultipleSelectHierarchy from "../../../../../components/common/MultipleSelectHierarchy";
import TrainingListFormPresenter from "./TrainingListFormPresenter";
import { Select, Space } from "antd";
import FormFactory from "../../../../../components/FormFactory";
export default class TrainingListForm extends BaseFormPage {
  constructor(props) {
    super(props);
    this.presenter = new TrainingListFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );

    this.state = {
      designations: [],
      selectedDesignations: [],
      hierarchy: {},
    };
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const designations = await findObjectUseCase().execute("position_titles", {
      includes: ["salaryPointer"],
    });

    const sortedDesignations = designations.sort((a, b) => {
      const nameA = a.salaryPointer?.name?.toLowerCase() || ""; // Handle undefined/null
      const nameB = b.salaryPointer?.name?.toLowerCase() || "";
      return nameA.localeCompare(nameB);
    });

    this.setState({ designations: sortedDesignations });

    if (Object.keys(this.props.object).length > 0) {
      const { object } = this.props;
      const newState = {
        ...this.state,
        ...object,
        hierarchy: {
          regions: object.selectedRegions,
          offices: object.selectedOffices,
          divisions: object.selectedDivisions,
          sections: object.selectedSections,
          units: object.selectedUnits,
          plantilla: object.selectedPlantilla,
        },
        designations: sortedDesignations,
      };
      this.setState(newState);
    }
  }

  getCollectionName() {
    return "management_training";
  }

  checkBox() {
    this.setState((prevState) => ({
      selectAllEmployee: !prevState.selectAllEmployee,
    }));
  }

  handleRemove = (label, itemToRemove) => {
    this.setState((prevState) => ({
      [`selected${label}`]: prevState[`selected${label}`].filter(
        (item) => item !== itemToRemove
      ),
    }));
  };

  DialogConfirmation(title, submitData) {
    dialog.fire({
      html: (
        <div className="p-2">
          <div className="row">
            <h4>{title}</h4>
            <hr />
            <p style={{ fontSize: "13px", padding: "1rem" }}>
              Click Confirm to continue!
            </p>
            <hr />
          </div>
          <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={() => dialog.close()}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              onClick={async () => {
                upsertUseCase().execute("management_training", submitData);

                if (submitData.stats === "Done") {
                  const NOTIFICATION_MESSAGE =
                    "Training has been completed. You can now evaluate the training.";
                  const NOTIFICATION_RECEIVER = ["role:user"];
                  const NOTIFICATION_REDIRECT = "training";

                  createNotification(
                    NOTIFICATION_MESSAGE,
                    NOTIFICATION_RECEIVER,
                    NOTIFICATION_REDIRECT
                  );
                } else {
                  //  CREATE NOTIFICATION
                  const NOTIFICATION_MESSAGE =
                    "You have a new notification for the Employee Training and Development Program";
                  const NOTIFICATION_RECEIVER = ["role:user"];
                  const NOTIFICATION_REDIRECT = "training";

                  createNotification(
                    NOTIFICATION_MESSAGE,
                    NOTIFICATION_RECEIVER,
                    NOTIFICATION_REDIRECT
                  );
                }
                dialog.close();
                this.props.closeTrainingForm();
                this.props.refetchData();
              }}
            >
              Confirm
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  }

  render() {
    const { formMode, datefrom, dateto, coveredFrom, coveredTo } = this.props;
    // console.warn("OBNBBB: ", this.state);
    const schema = this.getSchema(this.getCollectionName());
    const includeFIeld = [
      "firstSignatory",
      "firstpos",
      "secondSignatory",
      "secondpos",
      "thirdSignatory",
      "thirdpos",
      "fourthSignatory",
      "fourthpos",
      "trainingType",
      "venue",
      "trainingMethod",
      "trainers",
    ];
    const assignatoryField = Object.keys(schema.fields).filter(
      (key) => !includeFIeld.includes(key)
    );
    return (
      <>
        <FloatingForm width="50rem">
          <CardView style={{ padding: 0 }}>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                this.presenter.hanldeSubmit();
              }}
            >
              <h4 className="fs-6 fw-bold pt-3 ps-3">
                {formMode === "Add"
                  ? "Add Training"
                  : formMode === "Edit"
                  ? "Edit Training"
                  : "View Training"}
              </h4>
              <hr />
              <div className="w-100 pt-3" style={{ padding: "0 1.5rem" }}>
                <div className="row">
                  <div className="col-lg-6">
                    <label className="mb-2 fs-6">
                      Training Name <span className="text-danger">*</span>
                    </label>
                    <InputFactory
                      type="String"
                      required
                      value={this.state.training}
                      disabled={this.props.action === "view"}
                      onChange={(value) =>
                        this.presenter.onChangeForm("training", value)
                      }
                    />
                  </div>
                  <div className="col-lg-6">
                    <label className="mb-2 fs-6">
                      Status <span className="text-danger">*</span>
                    </label>
                    <SearchSelect
                      required
                      value={this.state.stats}
                      onChange={(value) =>
                        this.presenter.onChangeForm("stats", value)
                      }
                      disabled={this.props.action === "view"}
                      onClickClear={() =>
                        this.presenter.onChangeForm("stats", "")
                      }
                      options={["New", "Done", "Ongoing", "Cancelled"].map(
                        (stats) => ({
                          label: stats,
                          value: stats,
                        })
                      )}
                    />
                  </div>
                  <div className="col-lg-12 mt-4 mb-4">
                    <label className="mb-2 fs-6">
                      Training Details <span className="text-danger">*</span>
                    </label>
                    <RichText
                      required
                      onContentChange={(value) =>
                        this.presenter.onChangeForm("trainingDetails", value)
                      }
                      disabled={this.props.action === "view"}
                      content={this.state.trainingDetails}
                    />
                  </div>
                  <div className="mb-4">
                    <input
                      type="checkbox"
                      onChange={this.checkBox.bind(this)}
                      checked={this.state.selectAllEmployee}
                      disabled={this.props.action === "view"}
                    />{" "}
                    Select All Employees
                  </div>

                  <MultipleSelectHierarchy
                    className="col-lg-4"
                    object={this.state.hierarchy}
                    required={true}
                    handleObjectChange={this.presenter.handleHierarchyChange.bind(
                      this
                    )}
                    disabled={this.state.selectAllEmployee}
                  />

                  <Space direction="vertical" className="col-lg-6">
                    <label className="mb-1" style={{ fontSize: "14px" }}>
                      Designation <span className="text-danger">*</span>
                    </label>

                    <Select
                      mode="multiple"
                      className="mb-3"
                      allowClear
                      size="large"
                      placeholder={`Please Select Designation`}
                      value={this.state.selectedDesignations}
                      disabled={this.state.selectAllEmployee}
                      onChange={(value) =>
                        this.presenter.onChangeForm(
                          "selectedDesignations",
                          value
                        )
                      }
                      options={this.state.designations?.map((stats) => ({
                        label: `${stats?.salaryPointer?.name} - ${stats?.position_title}`,
                        value: `${stats?.salaryPointer?.name} - ${stats?.position_title}`,
                      }))}
                      style={{
                        width: "100%",
                      }}
                    />
                  </Space>

                  {/* <div className="col-lg-6 mb-4">
                    <label className="mb-2 fs-6">
                      Trainers/Facilitators{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <InputFactory
                      required
                      type="String"
                      field="trainers"
                      value={this.state.trainers}
                      disabled={this.props.action === "view"}
                      onChange={(value) =>
                        this.presenter.onChangeForm("trainers", value)
                      }
                    />
                  </div> */}
                  <div className="col-lg-6 mb-4">
                    <label className="fs-6 mb-2">Resource Person</label>
                    <div className="d-grid gap-4 p-0">
                      {["personName", "personContact", "personEmail"].map(
                        (label, index) => {
                          const placeHolder = {
                            personName: "Name",
                            personContact: "Contact",
                            personEmail: "Email",
                          };
                          return (
                            <InputFactory
                              key={index}
                              placeholder={placeHolder[label]}
                              type="String"
                              field={label}
                              value={this.state[label]}
                              disabled={this.props.action === "view"}
                              onChange={(value) =>
                                this.presenter.onChangeForm(label, value)
                              }
                            />
                          );
                        }
                      )}
                    </div>
                  </div>
                  {/* <div className="col-lg-6 mb-4">
                    <label className="mb-2 fs-6">
                      Methods <span className="text-danger">*</span>
                    </label>
                    <SearchSelect
                      required
                      value={this.state.trainingMethod}
                      disabled={this.props.action === "view"}
                      onChange={(value) =>
                        this.presenter.onChangeForm("trainingMethod", value)
                      }
                      onClickClear={() =>
                        this.presenter.onChangeForm("trainingMethod", "")
                      }
                      options={[
                        "Face to Face",
                        "Virtual - Synchronous",
                        "Virtual - Asynchronous",
                        "Virtual - Hybrid",
                      ].map((trainingMethod) => ({
                        label: trainingMethod,
                        value: trainingMethod,
                      }))}
                    />
                    <br></br>

                    <label className="mb-2 fs-6">Venue</label>

                    <InputFactory
                      type="String"
                      field="venue"
                      value={this.state.venue}
                      disabled={this.props.action === "view"}
                      onChange={(value) =>
                        this.presenter.onChangeForm("venue", value)
                      }
                    />
                  </div>
                  <div className="col-lg-6 mb-4">
                    <label className="mb-2 fs-6">Training Type</label>
                    <SearchSelect
                      value={this.state.trainingType}
                      disabled={this.props.action === "view"}
                      onChange={(value) =>
                        this.presenter.onChangeForm("trainingType", value)
                      }
                      onClickClear={() =>
                        this.presenter.onChangeForm("trainingType", "")
                      }
                      options={[
                        "Foundation",
                        "Managerial",
                        "Supervisory",
                        "Technical",
                      ].map((trainingType) => ({
                        label: trainingType,
                        value: trainingType,
                      }))}
                    />
                  </div> */}

                  <FormFactory
                    // disabled={object.stats !== "Approved"}
                    className="mb-2 col-lg-6"
                    schema={schema}
                    object={this.state}
                    onChange={(value, field) =>
                      this.presenter.onChangeForm(field, value)
                    }
                    excludeFields={assignatoryField}
                  />
                  {/* <div className="col-lg-12 d-grid">
                    <label className="mb-2 fs-6">Trainer Signature</label>
                    <FileUpload
                      accept=".jpg,.jpeg,.png,.gif,.bmp,.svg,.webp"
                      label={"Upload Documents"}
                      disabled={this.props.action === "view"}
                      attachments={this.state.trainingsignature}
                      onFileChange={(value) =>
                        this.presenter.onChangeForm("trainingsignature", value)
                      }
                    />
                  </div> */}
                  {[
                    "Date From",
                    "Date To",
                    "Duration",
                    "Time Start",
                    "Time End",
                    "Target Competency",
                    "Budgets",
                    "Costs",
                  ].map((label, index) => (
                    <div
                      className={`${
                        label === "Date From" ||
                        label === "Date To" ||
                        label === "Duration"
                          ? "col-lg-4 mb-4"
                          : label === "Target Competency"
                          ? "col-lg-12 mb-4"
                          : "col-lg-6 mb-2"
                      } mt-3`}
                      key={index}
                    >
                      <label className="mb-2 fs-6">
                        {label === "Duration" ? "Duration in hours" : label}
                        <span className="text-danger">*</span>
                      </label>
                      <InputFactory
                        type={
                          label === "Duration"
                            ? "Number"
                            : label === "Date From" || label === "Date To"
                            ? "Date"
                            : label === "Time Start" || label === "Time End"
                            ? "time"
                            : label === "Target Competency"
                            ? "Text"
                            : "parseNumber"
                        }
                        value={
                          this.state[label.replace(/\s+/g, "").toLowerCase()]
                        }
                        required
                        disabled={this.props.action === "view"}
                        onChange={(value) =>
                          this.presenter.onChangeForm(
                            label.replace(/\s+/g, "").toLowerCase(),
                            value
                          )
                        }
                      />
                    </div>
                  ))}
                  <div className="col-lg-12 d-grid">
                    <label className="mb-2 fs-6">Training Collateral</label>
                    <FileUpload
                      accept=".jpg,.jpeg,.png,.gif,.bmp,.svg,.webp,.pdf"
                      label={"Upload Documents"}
                      disabled={this.props.action === "view"}
                      attachments={this.state.trainingcollateral}
                      onFileChange={(value) =>
                        this.presenter.onChangeForm("trainingcollateral", value)
                      }
                    />
                  </div>

                  <div className="col-lg-12 d-grid">
                    <label className="mb-2 fs-6">Documents</label>
                    <FileUpload
                      accept=".jpg,.jpeg,.png,.gif,.bmp,.svg,.webp,.pdf"
                      label={"Upload Documents"}
                      disabled={this.props.action === "view"}
                      attachments={this.state.trainingdocuments}
                      onFileChange={(value) =>
                        this.presenter.onChangeForm("trainingdocuments", value)
                      }
                    />
                  </div>
                </div>
              </div>
              <hr />
              <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
                <button
                  className="btn btn-light"
                  onClick={() => this.props.closeTrainingForm()}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  // onClick={this.presenter.hanldeSubmit.bind(this)}
                  type="submit"
                  style={{
                    display: this.props.action === "view" ? "none" : "",
                  }}
                >
                  Submit
                </button>
              </div>
            </form>
          </CardView>
        </FloatingForm>
      </>
    );
  }
}
